import { Asset } from "lib/at-data/assets/Asset";
import { Assets } from "lib/at-data/assets/assets";
import { pipe } from "fp-ts/function";
import * as A from "fp-ts/Array";
import { AssetTagEq, AssetTagsEq } from "lib/at-api/asset-tags/assetTags";
import { getTags } from "lib/at-data/assets/getters";

export const collectTags = (assets: Assets) =>
  pipe(assets, A.chain(getTags), A.uniq(AssetTagEq));
